import { LimitedStore, RotationStore, SpecialStore, Store, WebhookStore } from '../icons'

interface StoreIconParams {
  storeType: 'special' | 'rotation' | 'limited_stock' | 'webhook' | 'default'
}

export const StoreIcon = ({ storeType }: StoreIconParams) => {
  switch (storeType) {
    case 'special':
      return <SpecialStore size={34} className="min-w-[34px]" />

    case 'rotation':
      return <RotationStore size={34} className="min-w-[34px]" />

    case 'limited_stock':
      return <LimitedStore size={34} className="min-w-[34px]" />

    case 'webhook':
      return <WebhookStore size={34} className="min-w-[34px]" />

    default:
      return <Store size={34} className="min-w-[34px]" />
  }
}
